import styled from 'styled-components';

export default styled.div`
  grid-area: date;
  justify-self: center;
  align-self: center;
`;
